import SearchResultsCard from '../../../ui/search-result-card/SearchResultsCard';
import { sortByWeightAndAlphabetical } from '../utils/sort-by-weight-and-alphabetical';
import c from '../category-new.module.scss';

export const Subcategory = ({ subcategoryName, links }) => {
  const sortedSubcategoryLinks = sortByWeightAndAlphabetical({
    list: links,
    weightKey: 'subcategoryWeight',
    alphabeticalKey: 'name',
  });

  return (
    <div key={subcategoryName} className={c.contentSection}>
      <h3 className={c.subheading}>{subcategoryName}</h3>
      <div className={c.links}>
        {sortedSubcategoryLinks.map((link, i) => (
          <SearchResultsCard entity={link} key={i} index={i} />
        ))}
      </div>
    </div>
  );
};
